module.exports = __webpack_public_path__ + "static/media/p2.024947ed.png";